angular
  .module("addressTable.components", [])
  .component("addressTable", {
    templateUrl: "ng/components/addressTable/addressTable.view.html",
    bindings: {
      /** Required data **/
      identifier: "<",
      visible: "<",
      digital: "<",
      ndg: "<",
      /**
       * Una lista di indirizzi da aggiungere a quelli trovati in NSIL
       */
      addresses: "<",
      onAddressPicked: "&?",
      selected: "="
    },
    controllerAs: "addressTableCtrl",
    controller: function ($nsilService, $componentUtility, $timeout, es6Factory, Sede) {
      /** not to loose *this reference **/
      var self = this;

      self.model = {
        addresses: [],
        initialized: false,
        visible: false,
        loading: false,
        loaded: false
      };

      self.$onInit = function () {
        self.model.initialized = true;
      };

      self.$onChanges = function (changed) {
        /**
         * Only the first time, we grab the identifier value
         */
        if ($componentUtility.bindingChangedFirstTime(changed, "identifier")) {
          self.identifier = changed.identifier.currentValue;
        }

        /**
         * As visibility changes, we update our value to show or hide the addressTable
         */
        if ($componentUtility.bindingChanged(changed, "visible")) {
          if (changed.visible && changed.visible.currentValue === true) {

            if (self.digital) {
              var identifier = self.ndg;
            } else {
              var identifier = self.identifier;
            }
            self.getAddresses(identifier);
          }
        }
      };

      self.getAddresses = function (identifier) {
        if (!self.model) return;

        self.model.loading = true;

        $nsilService
          .getAddress(identifier)
          .then(function (addresses) {

            if (self.digital) {
              self.model.addresses = addresses.reverse() || addresses;
            } else {
              //Concat nsil + given addresses if present            
              self.model.addresses = self.addresses && addresses.concat(self.addresses).reverse() || addresses;
            }

            self.selected = self.model.addresses[0];

            console.log('waiting..');

          })
          .catch(function (error) {
            console.error(error);
          })
          .finally(function () {

            $timeout(function () {
              console.log('waited');
              self.model.loading = false;
              self.model.loaded = true;
            }, 3000);

          });
      };

      self.onConfirm = function (picked) {
        self.onAddressPicked({
          address: self.model.addresses[picked]
        });
      };

      self.selectRow = function (address) {
        self.selected = Sede.build(address);
      }

      self.isRowSelected = function (index) {
        return es6Factory.compareObj(self.selected, self.model.addresses[index]);
      }


    }
  });